import { type FC, type ReactNode } from "react";
import { Pencil } from "lucide-react";

import { Button } from "@/shared/components/ui/button";
import { IconButton } from "@/shared/components/ui/icon-button";
import { Separator } from "@/shared/components/ui/separator";

export const DetailRow: FC<{
  label: string;
  value: string | null | undefined;
  onAdd?: () => void;
}> = ({ label, value, onAdd }) => (
  <div className="flex gap-6 items-start w-full">
    <p className="text-sm font-medium text-secondary w-[180px] shrink-0">{label}</p>
    {value ? (
      <p className="text-sm font-medium whitespace-pre-line">{value}</p>
    ) : (
      <Button variant="link" className="text-brand" onClick={onAdd}>
        Add
      </Button>
    )}
  </div>
);

export const DetailSection: FC<{
  title: string;
  onEdit?: () => void;
  children: ReactNode;
}> = ({ title, onEdit, children }) => (
  <div className="border border-primary rounded-lg">
    <div className="flex items-center gap-2 p-4">
      <p className="flex-1 text-base font-semibold">{title}</p>
      {onEdit && (
        <IconButton className="-my-2" onClick={onEdit} label={`Edit ${title}`} tooltip={false}>
          <Pencil />
        </IconButton>
      )}
    </div>
    <Separator />
    <div className="flex flex-col gap-4 p-4">{children}</div>
  </div>
);
